import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Spin} from 'antd'
import Chart from './Chart'
import Controls from './Controls'
import Modal from './Modal'

import style from './style.sass'

@inject('store') @observer
class ChartWrapper extends Component {
  state = {
    modal: false,
    indicator: null,
    xExtents: null,
    originalExtents: null,
    suffix: 1,
    brushEnabled: false
  }

  changeState = (obj) => {
    this.setState(obj)
  }
  calculateChartWidth = () => {
    if (!this.wrapper) {
      return window.innerWidth
    }
    const wrapperRect = this.wrapper.getBoundingClientRect()
    const controlsWidth = 52
    return wrapperRect.width - controlsWidth
  }
  removeIndicator = (type, ident) => {
    this.props.store.analysis.removeIndicator(type, ident)
  }
  showModal = (indicator) => {
    this.setState({modal:true, indicator})
  }
  handleOk = () => {
    this.setState({modal:false})
  }
  handleCancel = () => {
    this.setState({modal:false})
  }
  reset = () => {
    let {suffix} = this.state
    suffix++
    this.setState({suffix})
  }
  render() {
    const {chartData, indicators, compare, loading} = this.props.store.analysis
    const data = chartData.map(row => Object.assign({}, row))
    const {indicator, modal, xExtents, suffix, brushEnabled} = this.state
    return(
      <div ref={el => this.wrapper = el} styleName='wrapper'>
        <Modal
          visible={modal}
          indicator={indicator}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
        />
        {loading
          ? <Spin size='large'>
            <div style={{width: '100%'}}/>
          </Spin>
          : chartData.length > 1
            ? <div>
              <Chart
                data={data}
                indicators={indicators}
                compare={compare}
                showModal={this.showModal}
                xExtents={xExtents}
                suffix={suffix}
                reset={this.reset}
                brushEnabled={brushEnabled}
                changeState={this.changeState}
              />
              <Controls
                data={data}
                xExtents={xExtents}
                originalExtents={this.state.originalExtents}
                changeState={this.changeState}
              />
            </div>
            : null
        }
      </div>
    )
  }
}

export default ChartWrapper
